import axios from 'axios'
import { useAuthStore } from '../stores/authStore'

// 创建axios实例
const apiClient = axios.create({
  baseURL: '/api', // 通过Vite代理
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器 - 添加token
apiClient.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuthStore.getState()
    
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器 - 处理token刷新和错误
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    
    // 如果是401错误且未重试过，尝试刷新token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true
      
      try {
        const { refreshToken } = useAuthStore.getState()
        
        if (!refreshToken) {
          throw new Error('没有刷新令牌')
        }
        
        // 调用刷新token接口
        const response = await axios.post('/api/v1/auth/refresh', {
          refresh_token: refreshToken
        })
        
        const { access_token, refresh_token } = response.data
        
        // 更新store中的tokens
        useAuthStore.getState().setTokens(access_token, refresh_token)
        
        // 更新原请求的Authorization头
        originalRequest.headers.Authorization = `Bearer ${access_token}`
        
        // 重新发送原请求
        return apiClient(originalRequest)
      } catch (refreshError) {
        // 刷新失败，清除认证状态
        useAuthStore.getState().clearAuth()
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }
    
    // 其他错误处理
    if (error.response?.status === 403) {
      // 权限不足
      console.error('权限不足')
    }
    
    return Promise.reject(error)
  }
)

export default apiClient